define.alias("ember-truth-helpers/helpers/eq", "media/helpers/eq");